import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'nk-card-content',
  imports: [CommonModule],
  templateUrl: './card-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardContentComponent {
  @Input() public type: string | undefined;
  @Input() public noPadding = false;
  @Input() public andClass = '';
}
